import script from "./mobile-menu.vue?vue&type=script&lang=ts&setup=true"
export * from "./mobile-menu.vue?vue&type=script&lang=ts&setup=true"

import "./mobile-menu.vue?vue&type=style&index=0&id=aae62748&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./mobile-menu.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "./mobile-menu.vue?vue&type=custom&index=1&blockType=i18n&locale=ko"
if (typeof block1 === 'function') block1(script)
import block2 from "./mobile-menu.vue?vue&type=custom&index=2&blockType=i18n&locale=ja"
if (typeof block2 === 'function') block2(script)


import exportComponent from "/Users/macmini/builds/VJ28wZh6J/0/terracycle/tc-mini-site-frontend/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aae62748"]])

export default __exports__